import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/Forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { DndModule } from 'ng2-dnd';
import { MarkdownModule } from 'angular2-markdown';

import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { ProjectsComponent } from './components/projects/projects.component';
import { ListsComponent } from './components/lists/lists.component';
import { AppRoutingModule } from './/app-routing.module';
import { ContactsComponent } from './components/contacts/contacts.component';
import { ProjectsService } from './services/projects.service';
import { ListsService } from './services/lists.service';
import { ContactsService } from './services/contacts.service';
import { ContactComponent } from './components/contact/contact.component';
import { ContactService } from './services/contact.service';
import { ListService } from './services/list.service';
import { ProjectService } from './services/project.service';
import { ProjectComponent } from './components/project/project.component';
import { ListComponent } from './components/list/list.component';
import { NotesComponent } from './components/notes/notes.component';
import { NotesService } from './services/notes.service';
import { WallComponent } from './components/wall/wall.component';
import { WallService } from './services/wall.service';
import { RoutineComponent } from './components/routine/routine.component';
import { RoutineService } from './services/routine.service';
import { DeletedService } from './services/deleted.service';
import { DeletedComponent } from './components/deleted/deleted.component';
import { LoginComponent } from './components/login/login.component';
import { LoginService } from './services/login.service';
import { AuthService } from './services/auth.service';
import { UserComponent } from './components/user/user.component';
import { SettingsService } from './services/settings.service';
import { HomeService } from './services/home.service';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    SidebarComponent,
    NavbarComponent,
    ProjectsComponent,
    ListsComponent,
    ContactsComponent,
    ContactComponent,
    ProjectComponent,
    ListComponent,
    NotesComponent,
    WallComponent,
    RoutineComponent,
    DeletedComponent,
    LoginComponent,
    UserComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    RouterModule, 
    HttpClientModule,
    DndModule.forRoot(),
    MarkdownModule.forRoot()
  ],
  exports: [DndModule],
  providers: [ProjectsService, ListsService, ContactsService, ContactService, ListService, ProjectService, NotesService, WallService, RoutineService, DeletedService, LoginService, AuthService, SettingsService, HomeService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts